// extracted by mini-css-extract-plugin
export default {"wrapper":"PT-z","availablePromoMessagesLabel":"QT-z","promoMessageList":"RT-z","promoMessage":"ST-z","appliedPromoMessage":"TT-z","promoMessageAmount":"UT-z"};